module.exports = __webpack_public_path__ + "img/down-arrow.749c4b17.svg";